import { ResultModelDto } from '@treasury/api/channel';
import { TmApiError } from '../shared';

function extractMessage(dto: ResultModelDto) {
    return dto.validationResults?.map(result => result.message).join(', ');
}

export class RemoteDepositError extends TmApiError {
    constructor(message: string, results?: ResultModelDto) {
        super({
            message: `${message}: ${results ? extractMessage(results) : ''}`,
        });
        this.results = results;
    }

    public results?: ResultModelDto;
}
